import { useState } from 'react';
import Text from '../Base/Text/Text';
// @ts-ignore
import styles from './SideFilter.module.scss';

interface ISideFilterLabel {
	tx: string;
	firstUpper?: boolean;
}

export default function SideFilterLabel(props: ISideFilterLabel) {
	const { tx, firstUpper } = props;

	return <Text className={styles.title} tx={tx} firstUpper={firstUpper} />;
}
